import { AxiosResponse } from "axios";
import {
    ComboBox,
    DefaultButton,
    IComboBox,
    IComboBoxOption,
    Modal,
    PrimaryButton,
    Stack,
    TextField
} from '@fluentui/react';
import React, { Component, RefObject } from "react";
import { connect } from 'react-redux';
import { Action } from "redux";
import { localize } from "src/l10n";
import { MarketplaceWidget, WidgetSelectionPopup } from 'src/marketplace';
import { setConfirmPopup } from "src/popups/actions";
import FilePicker from 'src/spintr/components/FilePicker';
import { IApplicationState } from 'src/spintr/reducer';
import { SpintrTypes } from 'src/typings';
import { DivWithHoverActions, Label, Loader } from "src/ui";
import CoverImageButton from 'src/ui/components/Buttons/CoverImageButton/CoverImageButton';
import CustomDialog from "src/ui/components/Dialogs/CustomDialog";
import TinyEditorComponent from "src/ui/components/Tiny/TinyEditorComponent";
import { Style } from "src/ui/helpers";
import { generateUuid, uniqueId, validateRequiredTextField } from "src/utils";
import stripHtml from "src/utils/stripHtml";
import { FormControl, FormTokenizedObjectInput } from '../../Forms';
import "./EditableContentSections.scss";
import api from "src/spintr/SpintrApi";
import classNames from "classnames";
import TeaserBoxSelectionPopup from "../../TeaserBoxSelectionPopup";
import { TeaserBox } from "src/teaser-box";
import ExpandableField from "../../ExpandableField";
import "./links.scss"
import SpintrSearch from "../../SpintrList/SpintrSearch";
import UserList from "../../UserList";
import Visage2Icon from "src/visage2/Visage2Icon/Visage2Icon";
import { ProductsColumn } from "./ProductsColumn";
import { ExpandableFieldForm } from "./ExpandableFieldForm";
import { UberContentColumn, UberContentRow } from "../UberContent.types";
import { generateBlockAnchorId, getBlockLink } from "../utils";
import { FileSelector } from "src/spintr/components";
import AcademyTestFormQuestion from "src/academy/admin/AcademyTestFormQuestion/AcademyTestFormQuestion";
import "src/academy/admin/AcademyTestFormQuestion/AcademyTestFormQuestion.scss";
import { isMissingCorrectAnswer } from "src/academy/utils";
import UberContentDivider from "../UberContentDivider";
import UberContentHighlightedText, { IHighlightedTextContent, parseHighlightedTextContent } from "../UberContentHighlightedText";
import UberContentImages from "../UberContentImages";
import {
    IImageBlockImage,
    parseImageBlockContent,
    serializeImageBlockContent,
    toImageBlockImageFromSelection,
} from "../imageBlockContent";
import ImageBlockThumbnails from "./ImageBlockThumbnails";
import AcademySessionBlockForm, { IAcademySessionBlockContent } from "src/academy/admin/AcademySessionBlockForm/AcademySessionBlockForm";
import { SmallBody } from "src/components";

interface IProps {
    contentRow: UberContentRow;
    enableSharePointListSearch: boolean;
    enableCrocus?: boolean;
    enableDirekten?: boolean;
    enableMediaflow?: boolean;
    enableUnsplash?: boolean;
    enableTaxiFiles?: boolean;
    enabledColumnTypes?: SpintrTypes.UberContentSectionType[];
    isAcademy?: boolean;
    isAcademyGuide?: boolean;
    onManageSessions?: (blockKey: string) => void;
    confirmRemoveSessionBlock?: (blockKey: string, onConfirm: () => void) => void;
    instance?: any;
    ref?: any;
    isSmallViewMode: boolean;
    handleProps?: any;
    dispatch: (action: Action) => void;
    apps?: any;
    enableExtendedPageBlockTypes?: boolean;
    blockLinkUberId?: number;
}

interface IState {
    contentRow: any,
    imageSelectorColumnTmpId?: string;
    showAcademyCourseSelectorDialog: boolean;
    showFormSelectorDialog: boolean,
    showCalendarSelectorDialog: boolean,
    isLoadingAcademyCourses: boolean;
    isLoadingForms: boolean,
    isLoadingCalendars,
    columnTmpIdToAddFormTo?: any,
    columnTmpIdToAddWidgetTo?: any,
    columnTmpIdToAddFileTo?: any, // could possible merge these three?
    columnTmpIdToAddTeaserBoxTo?: any // four
    columnTmpIdToAddCalendarTo?: any // five
    columnTmpIdToAddAcademyCourseTo?: any; // six
    columnTmpIdToAddNewsFeedCategoryTo?: any;
    columnTmpIdToAddVideoTo?: any;
    academyCourses?: any;
    forms?: any,
    calendars?: any,
    selectedAcademyCourse?: any;
    selectedForm?: any
    selectedCalendar?: any
    showFilePicker: boolean;
    showWidgetSelector: boolean;
    showTeaserBoxSelector: boolean;
    showVideoSelector?: boolean;
    enableFieldValidation?: boolean;
    isKeyboardNavigation?: boolean;
    expandableTitle?: string;
    searchText: string;
    showNewsFeedCategorySelectorDialog?: boolean;
    isLoadingNewsFeedCategories?: boolean;
    newsCategories: Spintr.INewsCategory[];
    selectedNewsFeedCategory?: Spintr.INewsCategory;
    isCreatingNewsFeedCategory?: boolean;
    newsCategoryIsEmpty: boolean;
    newNewsFeedCategoryName?: string;
    copiedLinkColumnTmpId?: string;
    blockLinkToCopyManually?: string;
}

class EditableContentSectionsRow extends Component<IProps, IState> {
    protected observer: MutationObserver;
    protected typeSelector: RefObject<HTMLDivElement>;
    private copiedLinkTimeout: number;

    private contentTypes = [{
        typeId: SpintrTypes.UberContentSectionType.Text,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <div onDoubleClick={() => {this.editOnDoubleClick(cc)}}>
                        <div style={{
                            minHeight: "1em",
                            wordBreak: "break-word"
                        }}>
                            <div className="TinyFormattedContent" dangerouslySetInnerHTML={{ __html: cc.content }} />
                        </div>
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                return (
                    <div>
                        <TinyEditorComponent
                            id={"EditableContentSectionsRow" + cc.tmpId}
                            content={cc.content}
                            enableMediaflow={this.props.enableMediaflow}
                            enableUnsplash={this.props.enableUnsplash}
                            displaySaveButton={true}
                            saveOnClickOutside={true}
                            onSave={(content) => {
                                this.setState({
                                    enableFieldValidation: true
                                });
                                this.setState({
                                    enableFieldValidation: true
                                });
                                this.setState({
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                            if (contentColumn.tmpId === cc.tmpId) {
                                                return {
                                                    ...contentColumn,
                                                    state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                                    content
                                                }
                                            } else {
                                                return contentColumn;
                                            }
                                        })
                                    }
                                }, this.postUpdatedRowToParent);
                            }}
                            onChange={(content) => {
                                this.setState({
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                            if (contentColumn.tmpId === cc.tmpId) {
                                                return {
                                                    ...contentColumn,
                                                    content
                                                }
                                            } else {
                                                return contentColumn;
                                            }
                                        })
                                    }
                                }, this.postUpdatedRowToParent);
                            }} />
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.Preamble,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }

            return (
                <div className="EditPreamble" style={{
                    backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                    borderRadius: "12px",
                    padding: Style.getSpacingStr(3)
                }}>
                    <form>
                        <FormControl>
                            <TextField
                                label={localize("Ingress")}
                                multiline
                                value={cc.content}
                                onChange={(_event, content) => {
                                    this.setState({
                                        contentRow: {
                                            ...this.state.contentRow,
                                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                                if (contentColumn.tmpId === cc.tmpId) {
                                                    return {
                                                        ...contentColumn,
                                                        content
                                                    }
                                                } else {
                                                    return contentColumn;
                                                }
                                            })
                                        }
                                    }, this.postUpdatedRowToParent);
                            }} />
                        </FormControl>
                    </form>
                </div>
            )
        }
    },
    {
        typeId: SpintrTypes.UberContentSectionType.Image,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsEditing ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const images = parseImageBlockContent(cc.content);

                if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed && images.length > 0) {
                    return images.length === 1 ? (
                        <div className="ImageBlockPreview">
                            <img src={images[0].content} alt="" style={{ maxWidth: "100%" }} />
                        </div>
                    ) : (
                        <UberContentImages images={images} disableClick />
                    );
                }

                return this.renderImageBlockForm(cc, images);
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    },
    {
        typeId: SpintrTypes.UberContentSectionType.Video,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsEditing ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                    let contentObject;

                    if (cc.content) {
                        contentObject = JSON.parse(cc.content);
                    }

                    return <div className="contentSectionItem">
                        <CoverImageButton
                            icon="video"
                            placeholder={!contentObject ? localize("SELECT_VIDEO") : (localize("SELECTED_VIDEO") + ":")}
                            subPlaceholder={!contentObject ? undefined : (contentObject.name || localize("EMBEDDED"))}
                            onClick={() => this.setState({showVideoSelector: true, columnTmpIdToAddVideoTo: cc.tmpId})}
                        />
                        {this.state.showVideoSelector && this.state.columnTmpIdToAddVideoTo === cc.tmpId && <FileSelector
                        onlyVideo
                        fileTypesString={"video/*"}
                        fileTypes={["mov", "avi", "mp4", "mpg", "wmv", "flv", "webm", "mkv", "ogv"]}
                        onClose={() => {
                            this.setState({showVideoSelector: false});
                        }}
                        onSelect={(data, type) => {
                            if (!type) return

                            let content;
                            let file;

                            if (type === 7) {
                                if (data instanceof File) {

                                    content = {
                                        ticket: new Date().getTime().toString() + uniqueId(),
                                        name: data.name,
                                    };
                                    file = data;
                                } else {
                                    content = {
                                        videoUrl: data.name,
                                        thumbnailUrl: data.videoThumbnailUrl,
                                        name: data.displayName,
                                        id: data.id,
                                    }
                                }
                            } else if (type === 6) {
                                const stripTags = (input) => {
                                    return input.replace(/(<([^>]+)>)/gi, '');
                                };

                                if (!data.match(/<iframe|<video/gi)) {
                                    data = stripTags(data);

                                    // parse if it is link on youtube & vimeo
                                    const iframeStart = '<iframe style="width: 500px; height: 281px;" src="';
                                    const iframeEnd = '" frameborder="0" allowfullscreen></iframe>';
                                    const reUrlYoutube = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube\.com\S*[^\w\-\s])([\w\-]{11})(?=[^\w\-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
                                    const reUrlVimeo = /https?:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;

                                    if (data.match(reUrlYoutube)) {
                                        data = data.replace(reUrlYoutube, iframeStart + '//www.youtube.com/embed/$1' + iframeEnd);
                                    } else if (data.match(reUrlVimeo)) {
                                        data = data.replace(reUrlVimeo, iframeStart + '//player.vimeo.com/video/$2' + iframeEnd);
                                    }
                                }

                                content = {
                                    embedString: data,
                                };
                            }

                            const newContentRow = { ...this.state.contentRow };
                            for (const contentColumn of newContentRow.uberContentColumns) {
                                if (contentColumn.tmpId === cc.tmpId) {
                                    contentColumn.content = JSON.stringify(content);
                                    contentColumn.state = SpintrTypes.UberContentSectionState.IsDisplayed;
                                    contentColumn.file = file;
                                }
                            }

                            this.setState({
                                contentRow: newContentRow,
                                showVideoSelector: false,
                            }, this.postUpdatedRowToParent);
                        }}
                        sourcesToDisplay={[0, ...(this.isAppEnabled(SpintrTypes.SpintrApp.Media) ? [7] : [])]} />}
                    </div>
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    },
    {
        typeId: SpintrTypes.UberContentSectionType.IFrame,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon={"box-1"}
                            placeholder={localize("SELECTED_IFRAME")}
                            subPlaceholder={cc.content.split('src="')[1].split('"')[0]} />
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                const saveIframe = () => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                if (contentColumn.tmpId === cc.tmpId) {
                                    return {
                                        ...contentColumn,
                                        state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                        content: `<iframe width="100%" ${cc.iframeHeight ? `height=${cc.iframeHeight}` : ``
                                            } frameborder="0" src="${cc.iframeUrl}"></iframe>`,
                                    }
                                } else {
                                    return contentColumn;
                                }
                            })
                        }
                    }, this.postUpdatedRowToParent);
                }

                return (
                    <div className="EditableContentSectionsRow-IframeForm" style={{
                        backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                        minHeight: 150,
                        borderRadius: "12px",
                        padding: Style.getSpacingStr(3)
                    }}>
                        <form>
                            <FormControl>
                                <TextField
                                    className="textField"
                                    label={localize("Url")}
                                    autoFocus
                                    value={cc.iframeUrl}
                                    onChange={this.handleIframeUrlChange}
                                    name={cc.tmpId}
                                    required
                                    aria-required
                                    validateOnFocusIn
                                    validateOnFocusOut
                                    validateOnLoad={!!this.state.enableFieldValidation}
                                    onGetErrorMessage={validateRequiredTextField}
                                />
                            </FormControl>
                            <FormControl>
                                <TextField
                                    className="textField"
                                    label={localize("Hojd")}
                                    value={typeof (cc.iframeHeight) !== undefined ? cc.iframeHeight : 150}
                                    name={cc.tmpId}
                                    onChange={this.handleIframeHeightChange}
                                />
                            </FormControl>
                        </form>
                        <Stack horizontal={true} horizontalAlign="end">
                            <PrimaryButton
                                disabled={!cc.iframeUrl || cc.iframeUrl.length === 0}
                                onClick={() => {
                                    this.setState({
                                        enableFieldValidation: true
                                    });
                                    saveIframe();
                                }}
                                text={localize("Spara")}
                            />
                        </Stack>
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.Graph,
        render: (cc) => {
            return null;
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.Form,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const inlineFormPattern = /(?:class="redactorInlineFolder)\s([a-z]*-[0-9]*)">([A-Za-zÀ-ÖØ-öø-ÿ\d\s]*)/igm;

                let match, formId, formName;

                while ((match = inlineFormPattern.exec(cc.content))) {
                    formId = parseInt(match[1].match(/(\d+)/)[0]);

                    if (isNaN(formId)) {
                        continue;
                    }

                    formName = match[2];
                };

                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon={"row-vertical"}
                            placeholder={localize("SELECTED_FORM") + ":"}
                            subPlaceholder={formName} />
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon={"row-vertical"}
                            placeholder={localize("SELECT_FORM")}
                            onClick={() => {
                                this.setState({
                                    showFormSelectorDialog: true,
                                    isLoadingForms: true,
                                    columnTmpIdToAddFormTo: cc.tmpId
                                }, () => {
                                    api.get(`/api/v1/survey/list`, {
                                        params: {
                                            take: 9999,
                                            orderByColumn: "name"
                                        }
                                    }).then((response: AxiosResponse) => {
                                        const forms = response.data.filter(f => !f.isDeleted).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

                                        this.setState({
                                            isLoadingForms: false,
                                            forms,
                                            selectedForm: forms[0]
                                        });
                                    });
                                });
                            }} />
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.File,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsEditing && cc.content) {
                // if editing name
                const inlineFolderPattern = /(?:\<(?:span|font|p)[^\<]*?\>\[@Folder:([0-9]+)@\]\<\/(?:span|font|p)\>(.+?)\<(?:span|font|p)[^\<]*?\>\[\/@Folder@\]\<\/(?:span|font|p)\>)/gim;
                const inlineSharePointListSearchPattern = /<div><div><span class="redactorInlineFolder sharePoint">\[@SharePointListSearch:([0-9]+)@\]<\/span><\/div>(.+?)<div><span class="redactorInlineFolder">(.+?)<\/span><\/div><\/div>/gim;

                const folderMatches = inlineFolderPattern.exec(cc.content);
                const sharePointListSearchMatches = inlineSharePointListSearchPattern.exec(cc.content);

                const name =
                    cc.name ||
                    (folderMatches
                        ? stripHtml(folderMatches[2])
                        : sharePointListSearchMatches
                            ? stripHtml(sharePointListSearchMatches[2])
                            : "");

                const id = folderMatches
                    ? folderMatches[1]
                    : sharePointListSearchMatches
                        ? sharePointListSearchMatches[1]
                        : 0;

                return (
                    <div
                        className="EditableContentSectionsRow-IframeForm"
                        style={{
                            backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                            padding: Style.getSpacingStr(3),
                        }}
                    >
                        <form>
                            <FormControl>
                                <TextField
                                    className="textField"
                                    label={localize("Namn")}
                                    autoFocus
                                    value={name}
                                    onChange={this.handleAttachedFileNameChange}
                                    name={cc.tmpId}
                                    required
                                    aria-required
                                    validateOnFocusIn
                                    validateOnFocusOut
                                    validateOnLoad={!!this.state.enableFieldValidation}
                                    onGetErrorMessage={validateRequiredTextField}
                                    onKeyPress={(event) => {
                                        if (event.key === "Enter") {
                                            event.stopPropagation(); // Prevents page from reloading
                                            event.preventDefault();
                                            this.saveAttachedFileName(cc, name, id, folderMatches, sharePointListSearchMatches);
                                        }}}
                                />
                            </FormControl>
                        </form>
                        <Stack horizontal={true} horizontalAlign="end">
                            <PrimaryButton
                                disabled={!name || name.length === 0}
                                onClick={() => {
                                    this.setState({
                                        enableFieldValidation: true
                                    });
                                    this.setState({
                                        enableFieldValidation: true
                                    });
                                    this.saveAttachedFileName(cc, name, id, folderMatches, sharePointListSearchMatches);
                                }}
                                text={localize("Spara")}
                            />
                        </Stack>
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }

            const inlineFilePattern = /<div><div><span class="redactorSingleFile(?: external)?">(.+?)<\/span><\/div>(.+?)<div><span class="redactorSingleFile(?: external)?">(.+?)<\/span><\/div><\/div>/gim;
            const inlineFolderPattern = /<div><div><span class="redactorInlineFolder(?: external)?">(.+?)<\/span><\/div>(.+?)<div><span class="redactorInlineFolder(?: external)?">(.+?)<\/span><\/div><\/div>/gim;
            const inlineSharePointSearch = /<div><div><span class="redactorInlineFolder sharePoint">(.+?)<\/span><\/div>(.+?)<div><span class="redactorInlineFolder">(.+?)<\/span><\/div><\/div>/gim;

            const fileMatches = [] as RegExpExecArray[];
            const folderMatches = [] as RegExpExecArray[];
            const sharePointSearchMatches = [] as RegExpExecArray[];

            let match: RegExpExecArray | null;

            while ((match = inlineFilePattern.exec(cc.content))) {
                fileMatches.push(match);
            }

            while ((match = inlineFolderPattern.exec(cc.content))) {
                folderMatches.push(match);
            }

            while ((match = inlineSharePointSearch.exec(cc.content))) {
                sharePointSearchMatches.push(match);
            }

            const selectionsCount = fileMatches.length + folderMatches.length + sharePointSearchMatches.length;

            let name: string;

            if (selectionsCount > 1) {
                name = `${selectionsCount} ${localize("Filer")}`;
            } else if (fileMatches[0]?.length >= 3) {
                name = fileMatches[0][2];
            } else if (folderMatches[0]?.length >= 3) {
                name = folderMatches[0][2];
            } else if (sharePointSearchMatches[0]?.length >= 3) {
                name = sharePointSearchMatches[0][2];
            }

            let selectedTypeLanguage: string;
            let icon: string;

            if (fileMatches.length > 0) {
                selectedTypeLanguage = "SELECTED_FILE";
                icon = "folder";
            } else if (folderMatches.length > 0) {
                selectedTypeLanguage = "SELECTED_FOLDER";
                icon = "folder";
            } else if (sharePointSearchMatches.length > 0) {
                selectedTypeLanguage = "SELECTED_SEARCH";
                icon = "search-normal-1";
            } else {
                icon = "folder";
            }

            const placeholder =
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayed
                    ? localize(selectedTypeLanguage) + ":"
                    : localize("BifogaFiler");

            return (
                <>
                    <div
                        className="contentSectionItem"
                    >
                        <CoverImageButton
                            icon={icon}
                            placeholder={placeholder}
                            subPlaceholder={name}
                            onClick={() => {
                                this.setState({
                                    showFilePicker: true,
                                    columnTmpIdToAddFileTo: cc.tmpId,
                                });
                            }}
                        />
                    </div>
                </>
            );
        },
    }, {
        typeId: SpintrTypes.UberContentSectionType.DataWidget,
        render: (column: any) => {
            if (column.type !== SpintrTypes.UberContentSectionType.DataWidget) {
                return null;
            }

            if (column.state === SpintrTypes.UberContentSectionState.IsEditing) {
                const onSelectClick = () => this.setState({
                    columnTmpIdToAddWidgetTo: column.tmpId,
                    showWidgetSelector: true,
                });

                return (
                    <div
                        className="contentSectionItem"
                    >
                        <CoverImageButton
                            icon={"chart"}
                            placeholder={localize("Valj")}
                            onClick={onSelectClick}
                        />
                    </div>
                );
            }

            if (
                column.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                column.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign
            ) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(column)
                        }
                        {
                            column.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(column) :
                                null
                        }
                    </div>
                )
            }

            return (
                <div style={{
                    margin: "0 auto",
                }}>
                    <MarketplaceWidget
                        id={column.content}
                        autoWidth
                        displayBorder
                    />
                </div>
            );
        },
    },
    {
        typeId: SpintrTypes.UberContentSectionType.TeaserBox,
        render: (column: any) => {
            if (column.type !== SpintrTypes.UberContentSectionType.TeaserBox) {
                return null;
            }

            if (column.state === SpintrTypes.UberContentSectionState.IsEditing) {
                const onSelectClick = () => this.setState({
                    columnTmpIdToAddTeaserBoxTo: column.tmpId,
                    showTeaserBoxSelector: true,
                });

                return (
                    <div
                        className="contentSectionItem"
                    >
                        <CoverImageButton
                            icon={"box-1"}
                            placeholder={localize("Valj")}
                            onClick={onSelectClick}
                        />
                    </div>
                );
            }

            if (
                column.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                column.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign
            ) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(column)
                        }
                        {
                            column.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(column) :
                                null
                        }
                    </div>
                )
            }

            return (
                <div className="teaserbox-textpage" style={{
                    margin: "0 auto",
                }}>
                    <TeaserBox
                        id={column.content}
                        showBorder
                        onUnavailable={() => this.onTeaserBoxUnavailable(column.tmpId)}
                    />
                </div>
            );
        },
    },
    {
        typeId: SpintrTypes.UberContentSectionType.Calendar,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const inlineCalendarPattern = /(?:class="redactorInlineFolder)\s([a-z]*-[0-9]*)">([A-Za-zÀ-ÖØ-öø-ÿ\d\s]*)/igm;

                let match, calendarId, calendarName;

                while ((match = inlineCalendarPattern.exec(cc.content))) {
                    calendarId = parseInt(match[1].match(/(\d+)/)[0]);

                    if (isNaN(calendarId)) {
                        continue;
                    }

                    calendarName = match[2];
                };

                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon={"calendar"}
                            placeholder={localize("SELECTED_CALENDAR") + ":"}
                            subPlaceholder={calendarName} />
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon={"calendar"}
                            placeholder={localize("ValjKalender")}
                            onClick={() => {
                                this.setState({
                                    showCalendarSelectorDialog: true,
                                    isLoadingCalendars: true,
                                    columnTmpIdToAddCalendarTo: cc.tmpId
                                }, () => {
                                    api.get(`/api/v1/calendar/currentuser`, {
                                        params: {
                                            take: 9999,
                                            orderByColumn: "name"
                                        }
                                    }).then((response: AxiosResponse) => {
                                        const calendars = response.data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

                                        this.setState({
                                            isLoadingCalendars: false,
                                            calendars,
                                            selectedCalendar: calendars[0]
                                        });
                                    });
                                });
                            }} />
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    },
    {
        typeId: SpintrTypes.UberContentSectionType.ExpandableField,
        render: (cc) => {
            let contentObject = { text: "", title: "" };

            if (cc.content) {
                try {
                    contentObject = JSON.parse(cc.content)
                } catch {
                    contentObject = { text: "", title: "" };
                }
            }

            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <div onDoubleClick={() => {
                        if (window.getSelection) {
                            // prevent weird selection issue in chrome when double clicking on text block
                            window.getSelection().empty();
                        }

                        this.setState({
                            contentRow: {
                                ...this.state.contentRow,
                                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                    return {
                                        ...contentColumn,
                                        state: contentColumn.tmpId === cc.tmpId ?
                                            SpintrTypes.UberContentSectionState.IsEditing :
                                            contentColumn.state
                                    }
                                })
                            }
                        }, this.postUpdatedRowToParent);
                    }}>
                        <div style={{
                            minHeight: "1em",
                            wordBreak: "break-word"
                        }}>
                            <ExpandableField title={contentObject.title} text={contentObject.text} />
                        </div>
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                return (
                    <ExpandableFieldForm
                        column={cc}
                        enableFieldValidation={this.state.enableFieldValidation}
                        onColumnChanged={this.onColumnChanged} />
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    },
    {
        typeId: SpintrTypes.UberContentSectionType.Link,
        render: (cc) => {
            let contentObject = { url: "", title: "" };

            if (cc.content) {
                try {
                    contentObject = JSON.parse(cc.content)
                } catch {
                    contentObject = { url: "", title: "" };
                }
            }

            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <div style={{
                        backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                        minHeight: 52,
                        borderRadius: "12px"
                    }}>
                        <a href={contentObject.url} style={{ color: "#22234A" }}>
                            <div className="fs-body-2 InTextPageLinkButton">
                                <span className="InTextPageLinkButtonText">{contentObject.title}</span>
                                <Visage2Icon style={{ marginLeft: 8 }} color="dark-grey" icon="arrow-right-1" />
                            </div>
                        </a>
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {

                const saveLink = (contentObject) => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                if (contentColumn.tmpId === cc.tmpId) {
                                    return {
                                        ...contentColumn,
                                        state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                        content: JSON.stringify({ url: contentObject.url, title: contentObject.title })
                                    }
                                } else {
                                    return contentColumn;
                                }
                            })
                        }
                    }, this.postUpdatedRowToParent);
                }

                return (
                    <div className="EditableContentSectionsRow-IframeForm" style={{
                        backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                        minHeight: 150,
                        padding: Style.getSpacingStr(3),
                        borderRadius: "12px"
                    }}>
                        <form>
                            <FormControl>
                                <TextField
                                    className="textField"
                                    label={localize("Titel")}
                                    value={contentObject.title ?? ""}
                                    name={cc.tmpId}
                                    onChange={(ev, val) => this.handleLinkTitleChange(ev, val, cc)}
                                    autoFocus
                                    required
                                    aria-required
                                    validateOnFocusIn
                                    validateOnFocusOut
                                    validateOnLoad={!!this.state.enableFieldValidation}
                                    onGetErrorMessage={validateRequiredTextField}
                                />
                            </FormControl>
                            <FormControl>
                                <TextField
                                    className="textField"
                                    type="url"
                                    label={localize("Url")}
                                    value={contentObject.url}
                                    onChange={(ev, val) => this.handleLinkUrlChange(ev, val, cc)}
                                    name={cc.tmpId}
                                    required
                                    aria-required
                                    validateOnFocusOut
                                    onGetErrorMessage={validateRequiredTextField}
                                />
                            </FormControl>
                        </form>
                        <Stack horizontal={true} horizontalAlign="end">
                            <PrimaryButton
                                disabled={(!contentObject.url || contentObject.url.length === 0) || (!contentObject.title || contentObject.title.length === 0)}
                                onClick={() => {
                                    this.setState({
                                        enableFieldValidation: true
                                    });
                                    saveLink(contentObject);
                                }}
                                text={localize("Spara")}
                            />
                        </Stack>
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.UserList,
        render: (cc) => { 

            let contentObject = { title: "", items: [] };
            
            if(cc.content) {
                try {
                    contentObject = JSON.parse(cc.content)
                } catch {
                    contentObject = { title: "", items: [] };
                }
            }

            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <UserList data={cc.content}/>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {

                return (
                    <div className="EditableContentSectionsRow-IframeForm"
                        style={{
                            backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                            borderRadius: "12px",
                            padding: Style.getSpacingStr(3),
                        }}>
                    <FormControl>
                        <TextField
                            className="textField"
                            label={localize("Titel")}
                            value={contentObject.title ?? ""}
                            name={cc.tmpId}
                            required
                            aria-required
                            validateOnFocusIn
                            validateOnFocusOut
                            validateOnLoad={!!this.state.enableFieldValidation}
                            onGetErrorMessage={validateRequiredTextField}
                            onChange={(ev, val) => {
                                this.setState({
                                    enableFieldValidation: true,
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map(
                                            contentColumn => {
                                                if(contentColumn.tmpId === cc.tmpId) {
                                                    return {
                                                        ...contentColumn,
                                                        content: JSON.stringify({
                                                            title: val,
                                                            items: contentObject.items
                                                        })
                                                    }
                                                } else {
                                                    return contentColumn;
                                                }
                                            }
                                        )
                                    }
                                }, () => {
                                    this.postUpdatedRowToParent();
                                });
                            }}
                            autoFocus
                        />
                    </FormControl>
                    <FormControl>
                        <FormTokenizedObjectInput
                            items={contentObject.items}
                            types={[
                                SpintrTypes.UberType.User,
                            ]}
                            label={localize("Sok")}
                            required
                            onChange={(items) => {
                                this.setState({
                                    enableFieldValidation: true,
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                            if (contentColumn.tmpId === cc.tmpId) {
                                                return {
                                                    ...contentColumn,
                                                    content: JSON.stringify({
                                                        title: contentObject.title,
                                                        items: items
                                                    })
                                                }
                                            } else {
                                                return contentColumn;
                                            }
                                        })
                                    }
                                }, () => {
                                    this.postUpdatedRowToParent();
                                });
                            }}
                        />
                        </FormControl>
                        <Stack horizontal={true} horizontalAlign="end">
                        <PrimaryButton
                            onClick={() => {
                                this.setState({
                                    enableFieldValidation: true,
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                            if (contentColumn.tmpId === cc.tmpId) {
                                                return {
                                                    ...contentColumn,
                                                    state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                                }
                                            } else {
                                                return contentColumn;
                                            }
                                        })
                                    }
                                }, () => {
                                    this.postUpdatedRowToParent();
                                });
                            }}>
                            {localize("Spara")}
                        </PrimaryButton>
                        </Stack>
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                );
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.Direkten,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon={"shop"}
                            placeholder={localize("SELECTED_CATEGORY")}
                            subPlaceholder={cc.content}
                        />
                    </div>
                )
            } else if (cc.state == SpintrTypes.UberContentSectionState.IsEditing) {
                const saveDirekten = () => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                if (contentColumn.tmpId === cc.tmpId) {
                                    return {
                                        ...contentColumn,
                                        state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                        content: cc.category
                                    }
                                } else {
                                    return contentColumn;
                                }
                            })
                        }
                    }, this.postUpdatedRowToParent);
                };
                return (
                    <div className="contentSectionItem" style={{
                        padding: Style.getSpacingStr(3)
                    }}>
                        <FormControl>
                            <TextField
                                className="textField"
                                label={localize("Kategori")}
                                autoFocus
                                defaultValue={cc.content}
                                value={cc.category}
                                onChange={this.handleDirektenCategoryChange}
                                name={cc.tmpId}
                                required
                                aria-required
                                validateOnFocusIn
                                validateOnFocusOut
                                validateOnLoad={!!this.state.enableFieldValidation}
                                onGetErrorMessage={validateRequiredTextField}
                            />
                        </FormControl>
                        <Stack horizontal={true} horizontalAlign="end">
                            <PrimaryButton
                                disabled={!cc.category || cc.category.length === 0}
                                onClick={() => {
                                    this.setState({
                                        enableFieldValidation: true
                                    });
                                    saveDirekten();
                                }}
                                text={localize("Spara")}
                            />
                        </Stack>
                    </div>
                )
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                );
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.Products,
        render: (column: UberContentColumn) => (
            <ProductsColumn
                column={column}
                enabeFieldValidation={this.state.enableFieldValidation}
                onColumnChanged={this.onColumnChanged} />
        ),
    }, {
        typeId: SpintrTypes.UberContentSectionType.TaxiFiles,
        render: () => (
            <>{localize("TAXI_FILES")}</>
        ),
    }, {
        typeId: SpintrTypes.UberContentSectionType.AcademyQuestion,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const contentObject = JSON.parse(cc.content);

                return (
                    <div className="contentSectionItem"
                        onDoubleClick={() => { this.editOnDoubleClick(cc); }}
                    >
                        <CoverImageButton
                            icon={"teacher"}
                            placeholder={localize("Fraga") + ":"}
                            subPlaceholder={contentObject.text}
                        />
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {

                    let text = "";
                    let alternatives = [];
                    let type = SpintrTypes.QuestionType.SimpleAnswer;
                    let answerPair;

                    if (cc.content) {
                        const contentObject = JSON.parse(cc.content);
                        text = contentObject.text;
                        alternatives = contentObject.alternatives;
                        type = contentObject.type ?? SpintrTypes.QuestionType.SimpleAnswer;
                        answerPair = contentObject.answerPair;
                    } else {
                        alternatives = [
                            {
                                id: 0,
                                tmpId: uniqueId(),
                            }, {
                                id: 1,
                                tmpId: uniqueId(),
                            }
                        ];
                    }

                    return <div className="EditableContentSectionsRow-IframeForm" style={{
                        backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                        padding: Style.getSpacingStr(3),
                        borderRadius: "12px"
                    }}>
                        <AcademyTestFormQuestion
                            question={{
                                text,
                                alternatives,
                                type,
                                answerPair,
                            }}
                            showValidation={!!cc.showQuestionValidation}
                            onUpdate={(u) => {
                                this.setState(() => ({
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                            if (contentColumn.tmpId !== cc.tmpId) {
                                                return contentColumn;
                                            }

                                            return {
                                                ...contentColumn,
                                                unsavedContent: u,
                                            }
                                        })
                                    }
                                }));
                            }}
                            hideHeader
                        />
                        <Stack horizontal horizontalAlign="end">
                            <PrimaryButton
                                text={localize("Spara")}
                                onClick={() => {
                                    const editedColumn = this.state.contentRow.uberContentColumns.find((contentColumn) => contentColumn.tmpId === cc.tmpId);
                                    const isInvalid = !editedColumn?.unsavedContent || isMissingCorrectAnswer(editedColumn.unsavedContent);

                                    this.setState(() => ({
                                        contentRow: {
                                            ...this.state.contentRow,
                                            uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                                if (contentColumn.tmpId !== cc.tmpId) {
                                                    return contentColumn;
                                                }

                                                if (isInvalid) {
                                                    return {
                                                        ...contentColumn,
                                                        showQuestionValidation: true,
                                                    }
                                                }

                                                return {
                                                    ...contentColumn,
                                                    content: JSON.stringify(contentColumn.unsavedContent),
                                                    state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                                    showQuestionValidation: false,
                                                }
                                            })
                                        }
                                    }), isInvalid ? undefined : this.postUpdatedRowToParent);
                                }}
                            />
                        </Stack>
                    </div>
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {
                            this.renderColumnPlusSign(cc)
                        }
                        {
                            cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                                this.renderColumnTypeSelector(cc) :
                                null
                        }
                    </div>
                )
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.AcademyTask,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const contentObject = JSON.parse(cc.content);

                return (
                    <div className="contentSectionItem"
                        onDoubleClick={() => { this.editOnDoubleClick(cc); }}
                    >
                        <CoverImageButton
                            icon={"task"}
                            placeholder={localize("TASK") + ":"}
                            subPlaceholder={contentObject.text}
                        />
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                let text = "";
                let alternatives = [];

                if (cc.content) {
                    const contentObject = JSON.parse(cc.content);
                    text = contentObject.text;
                    alternatives = contentObject.alternatives;
                } else {
                    alternatives = [
                        {
                            id: 0,
                            tmpId: uniqueId(),
                        }, {
                            id: 1,
                            tmpId: uniqueId(),
                        }
                    ];
                }

                return <div className="EditableContentSectionsRow-IframeForm" style={{
                    backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                    padding: Style.getSpacingStr(3),
                    borderRadius: "12px"
                }}>
                    <div className="AcademyTestFormQuestion">
                        <div className="content">
                            <Label>{localize("TASKS")}</Label>
                            <AcademyTestFormQuestion
                                question={{
                                    text,
                                    alternatives,
                                    type: 2,
                                }}
                                onUpdate={(u) => {
                                    this.setState(() => ({
                                        contentRow: {
                                            ...this.state.contentRow,
                                            uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                                if (contentColumn.tmpId !== cc.tmpId) {
                                                    return contentColumn;
                                                }

                                                return {
                                                    ...contentColumn,
                                                    unsavedContent: u,
                                                }
                                            })
                                        }
                                    }));
                                }}
                                hideHeader
                                isTask
                            />
                        </div>
                    </div>
                    <Stack horizontal horizontalAlign="end">
                        <PrimaryButton
                            text={localize("Spara")}
                            onClick={() => {
                                this.setState(() => ({
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                            if (contentColumn.tmpId !== cc.tmpId) {
                                                return contentColumn;
                                            }

                                            return {
                                                ...contentColumn,
                                                content: JSON.stringify(contentColumn.unsavedContent),
                                                state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                            }
                                        })
                                    }
                                }), this.postUpdatedRowToParent);
                            }}
                        />
                    </Stack>
                </div>
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.AcademySession,
        render: (cc) => {
            const content: IAcademySessionBlockContent = {
                blockKey: "",
                title: "",
                description: "",
                ...(cc.content ? JSON.parse(cc.content) : {}),
            };

            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const canManageSessions = !!content.blockKey && !!this.props.onManageSessions;

                return (
                    <div className="contentSectionItem contentSectionItem-session"
                        onDoubleClick={() => { this.editOnDoubleClick(cc); }}
                    >
                        <CoverImageButton
                            icon={"calendar"}
                            placeholder={localize("SESSION") + ":"}
                            subPlaceholder={content.title}
                        />
                        {canManageSessions && (
                            <Stack horizontal horizontalAlign="center" className="session-manage-action">
                                <DefaultButton
                                    text={localize("SESSION_MANAGE_SESSIONS")}
                                    onClick={() => this.props.onManageSessions(content.blockKey)}
                                />
                            </Stack>
                        )}
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                const draft: IAcademySessionBlockContent = cc.unsavedContent ?? content;

                return <div className="EditableContentSectionsRow-IframeForm" style={{
                    backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                    padding: Style.getSpacingStr(3),
                    borderRadius: "12px"
                }}>
                    <AcademySessionBlockForm
                        content={draft}
                        onUpdate={(updated) => {
                            this.setState(() => ({
                                contentRow: {
                                    ...this.state.contentRow,
                                    uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                        if (contentColumn.tmpId !== cc.tmpId) {
                                            return contentColumn;
                                        }

                                        return {
                                            ...contentColumn,
                                            unsavedContent: updated,
                                        };
                                    })
                                }
                            }));
                        }}
                        onSave={() => {
                            this.setState(() => ({
                                contentRow: {
                                    ...this.state.contentRow,
                                    uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                        if (contentColumn.tmpId !== cc.tmpId) {
                                            return contentColumn;
                                        }

                                        return {
                                            ...contentColumn,
                                            content: JSON.stringify(contentColumn.unsavedContent ?? draft),
                                            state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                        };
                                    })
                                }
                            }), this.postUpdatedRowToParent);
                        }}
                    />
                </div>
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.AcademyCourse,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const inlineAcademyCoursePattern = /<span class="redactorAcademy academy-(.+?)(?: isGuide)?">(.+?)<\/span>/igm;

                let match, academyCourseId, academyCourseName;

                while ((match = inlineAcademyCoursePattern.exec(cc.content))) {
                    academyCourseId = parseInt(match[1].match(/(\d+)/)[0]);

                    if (isNaN(academyCourseId)) {
                        continue;
                    }

                    academyCourseName = match[2];
                };

                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon="teacher"
                            placeholder={localize(cc.content.includes("isGuide") ? "SELECTED_GUIDE" : "SELECTED_COURSE") + ":"}
                            subPlaceholder={academyCourseName}
                        />
                    </div>
                );
            } else if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon="teacher"
                            placeholder={localize("SELECT_COURSE_OR_GUIDE")}
                            onClick={() => {
                                this.setState({
                                    showAcademyCourseSelectorDialog: true,
                                    isLoadingAcademyCourses: true,
                                    columnTmpIdToAddAcademyCourseTo: cc.tmpId,
                                }, () => {
                                    api.get("/api/v1/academy/admin/courses", {
                                        params: {
                                            orderByColumn: "Name",
                                            skip: 0,
                                            take: 9999,
                                            isAscending: true,
                                            guidesAndCourses: true,
                                        },
                                    }).then((response) => {
                                        const courses = response.data.items
                                            .filter((c) => !c.isDraft && c.isPublished)
                                            .map((c) => ({
                                                key: c.id,
                                                id: c.id,
                                                text: c.name,
                                                isGuide: c.isGuide,
                                            }));

                                        this.setState({
                                            isLoadingAcademyCourses: false,
                                            academyCourses: courses,
                                            selectedAcademyCourse: courses[0],
                                        })
                                    });
                                })
                            }}
                        />
                    </div>
                )
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.NewsFeed,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {this.renderColumnPlusSign(cc)}
                        {cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                            this.renderColumnTypeSelector(cc) : null}
                    </div>
                );
            }

            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                const categoryName = this.state.newsCategories.find(
                    (cat) => String(cat.id) === String(cc.content)
                )?.name;

                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon="document-text"
                            placeholder={localize("SELECTED_NEWSCATEGORY") + ":"}
                            subPlaceholder={categoryName || ""}
                        />
                    </div>
                );
            }

            if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                return (
                    <div className="contentSectionItem">
                        <CoverImageButton
                            icon="document-text"
                            placeholder={localize("CHOOSE_NEWS_CATEGORY")}
                            onClick={() => {
                                this.openNewsFeedCategorySelector(cc.tmpId);
                            }}
                        />
                    </div>
                );
            }
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.Divider,
        render: (cc) => {
            if (cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ||
                cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
                return (
                    <div>
                        {this.renderColumnPlusSign(cc)}
                        {cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                            this.renderColumnTypeSelector(cc) : null}
                    </div>
                );
            }

            return (
                <UberContentDivider />
            );
        }
    }, {
        typeId: SpintrTypes.UberContentSectionType.HighlightedText,
        render: (cc) => {
            const contentObject = parseHighlightedTextContent(cc.content);

            if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed) {
                return (
                    <UberContentHighlightedText text={contentObject.text} sender={contentObject.sender} />
                );
            }

            if (cc.state === SpintrTypes.UberContentSectionState.IsEditing) {
                const updateContent = (updatedContent: IHighlightedTextContent, state?: SpintrTypes.UberContentSectionState) => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                                if (contentColumn.tmpId !== cc.tmpId) {
                                    return contentColumn;
                                }

                                return {
                                    ...contentColumn,
                                    state: state ?? contentColumn.state,
                                    content: JSON.stringify(updatedContent),
                                };
                            })
                        }
                    }, this.postUpdatedRowToParent);
                };

                return (
                    <div className="EditableContentSectionsRow-IframeForm" style={{
                        backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                        padding: Style.getSpacingStr(3),
                        borderRadius: "12px"
                    }}>
                        <form>
                            <FormControl>
                                <TextField
                                    className="textField highlightedTextField"
                                    label={localize("Text")}
                                    value={contentObject.text}
                                    multiline
                                    autoAdjustHeight
                                    rows={3}
                                    autoFocus
                                    required
                                    aria-required
                                    validateOnFocusIn
                                    validateOnFocusOut
                                    validateOnLoad={!!this.state.enableFieldValidation}
                                    onGetErrorMessage={validateRequiredTextField}
                                    onChange={(ev, val) => updateContent({ ...contentObject, text: val ?? "" })}
                                />
                            </FormControl>
                            <FormControl>
                                <TextField
                                    className="textField"
                                    label={localize("HIGHLIGHTED_TEXT_SENDER")}
                                    value={contentObject.sender}
                                    onChange={(ev, val) => updateContent({ ...contentObject, sender: val ?? "" })}
                                />
                            </FormControl>
                        </form>
                        <Stack horizontal={true} horizontalAlign="end">
                            <PrimaryButton
                                disabled={!contentObject.text.trim()}
                                onClick={() => {
                                    this.setState({
                                        enableFieldValidation: true
                                    });
                                    updateContent(contentObject, SpintrTypes.UberContentSectionState.IsDisplayed);
                                }}
                                text={localize("Spara")}
                            />
                        </Stack>
                    </div>
                );
            }

            return (
                <div>
                    {this.renderColumnPlusSign(cc)}
                    {cc.state === SpintrTypes.UberContentSectionState.IsSelectingType ?
                        this.renderColumnTypeSelector(cc) : null}
                </div>
            );
        }
    }];

    private fetchNewsFeedCategories = () => {
        this.setState({
            isLoadingNewsFeedCategories: true,
        }, () => {
            api.get<Spintr.INewsCategoryEnvelope>("/api/ubercategories?take=999&includeDeleted=false").then((response) => {
                this.setState({
                    isLoadingNewsFeedCategories: false,
                    newsCategories: response.data.items,
                });
            });
        });
    }

    private openNewsFeedCategorySelector = (columnTmpId: string, preselectedCategoryId?: string) => {
        const selected = preselectedCategoryId
            ? this.state.newsCategories.find((c) => String(c.id) === preselectedCategoryId)
            : this.state.newsCategories[0];
        
        this.setState({
            showNewsFeedCategorySelectorDialog: true,
            columnTmpIdToAddNewsFeedCategoryTo: columnTmpId,
            isCreatingNewsFeedCategory: false,
            newNewsFeedCategoryName: "",
            selectedNewsFeedCategory: selected,
            newsCategoryIsEmpty: selected ? selected.uberCount === 0 : false
        });
    }

    private handleConfirmNewsFeedCategoryDialog = () => {
        if (this.state.selectedNewsFeedCategory) {
            this.setState({
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                        if (contentColumn.tmpId === this.state.columnTmpIdToAddNewsFeedCategoryTo) {
                            return {
                                ...contentColumn,
                                content: String(this.state.selectedNewsFeedCategory.id),
                                state: SpintrTypes.UberContentSectionState.IsDisplayed
                            };
                        } else {
                            return contentColumn;
                        }
                    })
                },
                showNewsFeedCategorySelectorDialog: false
            }, this.postUpdatedRowToParent);
        }
    }

    private renderCreateNewNewsCategoryDialog() {
        return (
            <CustomDialog
                title={localize("NyKategori")}
                show={this.state.isCreatingNewsFeedCategory}
                onDismiss={() => { 
                    this.setState({ 
                        isCreatingNewsFeedCategory: false,
                        showNewsFeedCategorySelectorDialog: true
                    }); 
                }}
                onConfirm={() => {
                    const name = this.state.newNewsFeedCategoryName?.trim();
                                                    
                    if (!name) {
                        return;
                    }

                    api.post<Spintr.INewsCategory>("/api/v1/ubercategories/0", { name }).then((response) => {
                        const newCategory = response.data;
                        
                        this.setState({
                            newsCategories: [...this.state.newsCategories, newCategory],
                            selectedNewsFeedCategory: newCategory,
                            isCreatingNewsFeedCategory: false,
                            showNewsFeedCategorySelectorDialog: true,
                            newNewsFeedCategoryName: ""
                        });
                    });
                }}>
                    <Stack tokens={{ childrenGap: 12 }}>
                        <SmallBody>{localize("CREATE_NEW_NEWSCATEGORY_FOR_TEXTPAGE")}</SmallBody>
                        <FormControl label={localize("Namn")} required>
                            <TextField
                                value={this.state.newNewsFeedCategoryName || ""}
                                onChange={(_, newValue) => {
                                    this.setState({ newNewsFeedCategoryName: newValue || "" });
                                }}
                                placeholder={localize("Namn")}
                            />
                        </FormControl>
                    </Stack>
            </CustomDialog>
        );
    }

    private renderNewsFeedCategorySelectorDialog() {
        const options: IComboBoxOption[] = [];

        for (const cat of this.state.newsCategories) {
            options.push({ key: cat.id, text: cat.name });
        }

        options.push({ key: "__new__", text: localize("NyKategori") });

        return (
            <CustomDialog
                title={localize("NEWS_FEED")}
                show={this.state.showNewsFeedCategorySelectorDialog}
                onDismiss={() => { this.setState({ showNewsFeedCategorySelectorDialog: false }) }}
                onConfirm={this.handleConfirmNewsFeedCategoryDialog}>
                    <Stack tokens={{ childrenGap: 12 }}>
                        <SmallBody>{localize("CHOOSE_NEWS_CATEGORY_FOR_TEXTPAGE")}</SmallBody>
                        {this.state.isLoadingNewsFeedCategories ? (
                            <Loader />
                        ) : (
                            <FormControl label={localize("Nyhetskategori")}>
                                <ComboBox
                                    selectedKey={
                                        this.state.selectedNewsFeedCategory ? this.state.selectedNewsFeedCategory.id : null
                                    }
                                    onChange={(_, option?: IComboBoxOption) => {
                                        if (option?.key === "__new__") {
                                            this.setState({ 
                                                isCreatingNewsFeedCategory: true,
                                                showNewsFeedCategorySelectorDialog: false, 
                                                newNewsFeedCategoryName: "",
                                                newsCategoryIsEmpty: true
                                            });
                                        } else {
                                            const newsCategory = this.state.newsCategories.find(
                                                (c) => c.id === option.key
                                            );

                                            this.setState({
                                                selectedNewsFeedCategory: newsCategory,
                                                isCreatingNewsFeedCategory: false,
                                                newsCategoryIsEmpty: newsCategory?.uberCount === 0
                                            });
                                        }
                                    }}
                                    options={options}
                                />
                                {this.state.newsCategoryIsEmpty && (
                                    <Label color="grey" italic margin={{ top: "small" }}>{localize("NEWS_CATEGORY_IS_EMPTY_FOR_TEXTPAGE")}</Label>
                                )}
                            </FormControl>
                        )}
                    </Stack>
            </CustomDialog>    
        );
    }

    private onColumnChanged = (tmpId: string, callback: (column: UberContentColumn) => UberContentColumn): void => {
        this.setState({
            enableFieldValidation: true,
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(
                    (contentColumn: UberContentColumn) => contentColumn.tmpId === tmpId
                        ? callback(contentColumn)
                        : contentColumn
                ),
            },
        }, () => this.postUpdatedRowToParent());
    };

    constructor(props) {
        super(props);

        this.state = {
            contentRow: props.contentRow,
            isLoadingAcademyCourses: false,
            isLoadingForms: false,
            showFilePicker: false,
            showAcademyCourseSelectorDialog: false,
            showFormSelectorDialog: false,
            showWidgetSelector: false,
            searchText: "",
            showTeaserBoxSelector: false,
            showCalendarSelectorDialog: false,
            isLoadingCalendars: false,
            newsCategories: [],
            newsCategoryIsEmpty: false
        };

        if (!this.props.enableCrocus) {
            this.contentTypes = this.contentTypes.filter(
                (type) => type.typeId != SpintrTypes.UberContentSectionType.DataWidget,
            );
        }

        this.typeSelector = React.createRef();

        this.onDismissWidgetSelection = this.onDismissWidgetSelection.bind(this);
        this.onWidgetSelected = this.onWidgetSelected.bind(this);

        this.onDismissTeaserBoxSelection = this.onDismissTeaserBoxSelection.bind(this);
        this.onTeaserBoxSelected = this.onTeaserBoxSelected.bind(this);
        this.onTeaserBoxUnavailable = this.onTeaserBoxUnavailable.bind(this);

        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    public componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.addObserver();
        this.fetchNewsFeedCategories();
    }

    public componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        this.observer.disconnect();
        window.clearTimeout(this.copiedLinkTimeout);
    }

    private addObserver() {
        // put this into redux instead if needed in other places?
        const body = window.document.querySelector("body");
        this.observer = new MutationObserver(() => {
            const isKeyboardNavigation = body.classList.contains("ms-Fabric--isFocusVisible");

            if (this.state.isKeyboardNavigation !== isKeyboardNavigation) {
                this.setState({
                    isKeyboardNavigation
                });
            }
        });

        this.observer.observe(body, {
            attributes: true,
            attributeFilter: ["class"]
        });
    }

    public render() {
        return (
            <div>
                {this.renderContentRow()}
                {this.renderFormSelectorDialog()}
                {this.renderCalendarSelectorDialog()}
                {this.renderAcademyCourseSelectorDialog()}
                {this.renderNewsFeedCategorySelectorDialog()}
                {this.renderCreateNewNewsCategoryDialog()}
                {this.renderFilePicker()}

                {this.state.showWidgetSelector && (
                    <WidgetSelectionPopup
                        isShowing={true}
                        onDismiss={this.onDismissWidgetSelection}
                        onSelected={this.onWidgetSelected}
                    />
                )}
                {this.state.showTeaserBoxSelector && (
                    <TeaserBoxSelectionPopup
                        isShowing={true}
                        onDismiss={this.onDismissTeaserBoxSelection}
                        onSelected={this.onTeaserBoxSelected}
                        hideDataWidgets={true}
                    />
                )}
                {!!this.state.blockLinkToCopyManually && (
                    <CustomDialog
                        title={localize("KopieraLank")}
                        message={localize("KopieraLankenManuellt")}
                        show={true}
                        hideSecondaryBtn
                        onDismiss={() => { this.setState({ blockLinkToCopyManually: undefined }) }}
                        onConfirm={() => { this.setState({ blockLinkToCopyManually: undefined }) }}
                    >
                        <TextField
                            readOnly
                            value={this.state.blockLinkToCopyManually}
                            onFocus={(event) => { event.target.select() }}
                        />
                    </CustomDialog>
                )}
            </div>
        )
    }

    private onWidgetSelected(widget: Spintr.IMarketplaceLibraryWidget) {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(
                    (contentColumn: any) => contentColumn.tmpId !== this.state.columnTmpIdToAddWidgetTo
                        ? contentColumn
                        : {
                            ...contentColumn,
                            content: widget.id,
                            state: SpintrTypes.UberContentSectionState.IsDisplayed,
                        })
            },
            showWidgetSelector: false,
        }, this.postUpdatedRowToParent);
    }

    private onTeaserBoxSelected(teaserbox) {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(
                    (contentColumn: any) => contentColumn.tmpId !== this.state.columnTmpIdToAddTeaserBoxTo
                        ? contentColumn
                        : {
                            ...contentColumn,
                            content: teaserbox.id.toString(),
                            state: SpintrTypes.UberContentSectionState.IsDisplayed,
                        })
            },
            showTeaserBoxSelector: false,
        }, this.postUpdatedRowToParent);
    }

    private onDismissWidgetSelection() {
        this.setState({
            showWidgetSelector: false,
        });
    }

    private onDismissTeaserBoxSelection() {
        this.setState({
            showTeaserBoxSelector: false,
        });
    }

    private onTeaserBoxUnavailable(columnTmpId: number) {
        // The attached teaser box has been removed. Keep the column typed as
        // TeaserBox but put it back in the empty "select" state so the user
        // can pick another teaser box or remove the section.
        const column = this.state.contentRow.uberContentColumns.find(
            (contentColumn) => contentColumn.tmpId === columnTmpId
        );

        if (!column ||
            column.type !== SpintrTypes.UberContentSectionType.TeaserBox ||
            column.state !== SpintrTypes.UberContentSectionState.IsDisplayed) {
            return;
        }

        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(
                    (contentColumn) => contentColumn.tmpId !== columnTmpId
                        ? contentColumn
                        : {
                            ...contentColumn,
                            content: "",
                            state: SpintrTypes.UberContentSectionState.IsEditing,
                        })
            },
        }, this.postUpdatedRowToParent);
    }

    private handleClickOutside(event) {
        if (this &&
            this.state &&
            this.props &&
            this.typeSelector &&
            this.typeSelector.current &&
            !this.typeSelector.current.contains(event.target)) {
            this.setState({
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                        if (contentColumn.state === SpintrTypes.UberContentSectionState.IsSelectingType) {
                            return {
                                ...contentColumn,
                                state: SpintrTypes.UberContentSectionState.IsDisplayingPlusSign
                            }
                        } else {
                            return contentColumn;
                        }
                    })
                }
            });
        }
    }

    private handleIframeUrlChange = (ev, val) => {
        const targetId = parseInt(ev.target.name, 10);
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === ev.target.name) {
                        return {
                            ...contentColumn,
                            iframeUrl: val
                        }
                    } else {
                        return contentColumn;
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }

    private handleIframeHeightChange = (ev, val) => {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === ev.target.name) {
                        return {
                            ...contentColumn,
                            iframeHeight: val
                        }
                    } else {
                        return contentColumn;
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }

    private handleLinkUrlChange = (ev, val, column) => {
        let contentObject = { url: "", title: "" };

        if (column.content) {
            try {
                contentObject = JSON.parse(column.content)
            } catch {
                contentObject = { url: val, ...contentObject };
            }
        }

        contentObject.url = val;

        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === ev.target.name) {
                        return {
                            ...contentColumn,
                            content: JSON.stringify(contentObject)
                        }
                    } else {
                        return contentColumn;
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }

    private handleLinkTitleChange = (ev, val, column) => {
        let contentObject = { url: "", title: "" };

        if (column.content) {
            try {
                contentObject = JSON.parse(column.content)
            } catch {
                contentObject = { ...contentObject, title: val.substring(0, 70) };
            }
        }

        contentObject.title = val.substring(0, 70);

        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === ev.target.name) {
                        return {
                            ...contentColumn,
                            content: JSON.stringify(contentObject)
                        }
                    } else {
                        return contentColumn;
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }

    private handleDirektenCategoryChange = (ev, val) => {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === ev.target.name) {
                        return {
                            ...contentColumn,
                            category: val
                        }
                    } else {
                        return contentColumn;
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }

    private saveAttachedFileName = (cc, name, id, folderMatches, sharePointListSearchMatches) => {
        let newContent;
        if (folderMatches) {
            newContent =
                '<div><div><span class="redactorInlineFolder">[@Folder:' +
                id +
                "@]</span></div>" +
                name +
                '<div><span class="redactorInlineFolder">[/@Folder@]</span></div></div><br />';
        } else if (sharePointListSearchMatches) {
            newContent =
                '<div><div><span class="redactorInlineFolder sharePoint">[@SharePointListSearch:' +
                id +
                "@]</span></div>" +
                name +
                '<div><span class="redactorInlineFolder">[/@SharePointListSearch@]</span></div></div><br />';
        }

        this.setState(
            {
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                        if (contentColumn.tmpId === cc.tmpId) {
                            return {
                                ...contentColumn,
                                state: SpintrTypes.UberContentSectionState.IsDisplayed,
                                content: newContent,
                            };
                        } else {
                            return contentColumn;
                        }
                    }),
                },
            },
            this.postUpdatedRowToParent
        );
    };

    private handleAttachedFileNameChange = (ev, val) => {
        this.setState(
            {
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                        if (contentColumn.tmpId === ev.target.name) {
                            return {
                                ...contentColumn,
                                name: val,
                            };
                        } else {
                            return contentColumn;
                        }
                    }),
                },
            },
            this.postUpdatedRowToParent
        );
    };

    private renderTypeSearchBox = () => {
        return (
            <SpintrSearch
                classes="type-search searchBox"
                placeholder={localize("SokBlandBlock")}
                value={this.state.searchText}
                onChange={(event: React.ChangeEvent, searchText: string) => {
                    this.setState({ searchText });
                }} />
        );
    }

    onEnter = (e, fn) => {
        if (e.keyCode === 27) {
            e.preventDefault();
            fn();
        }

        if (e.keyCode === 13) {
            e.preventDefault();
            fn();
        }
    };

    private renderColumnType(index, text, icon, onClick) {
        return (
            <div key={index} className="columnType" tabIndex={0} role="button" onKeyUp={(e) => this.onEnter(e, onClick)}
                style={{
                    display: "inline-block",
                    width: "100%",
                }}>
                <div style={{
                    textAlign: "center"
                }}>
                    <a onClick={onClick} key={text}>
                        <div>
                            <div className="columnTypeInner" style={{
                                display: "inline-block",
                                // padding: Style.getSpacingStr(4)
                            }}>
                                <div style={{
                                    textAlign: "center"
                                }}>
                                    <div style={{
                                        display: "inline-block"
                                    }}>
                                        <Visage2Icon icon={icon} />
                                    </div>
                                </div>
                                <Label as="span" size="body-3" color="dark-grey">{text}</Label>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        )
    }

    private getImageSizeString = () => {
        let columnCount = 1;

        if (this.state.contentRow.uberContentColumns) {
            columnCount = this.state.contentRow.uberContentColumns.length;
        }

        const width = columnCount === 1 ? 930 : columnCount === 2 ? 460 : 300;

        return localize("OptimalBildBredd") + ": " + width + "px";
    }

    private renderImageBlockForm(cc, images: IImageBlockImage[]) {
        const updateImages = (updatedImages: IImageBlockImage[], state?: SpintrTypes.UberContentSectionState) => {
            this.setState({
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                        if (contentColumn.tmpId !== cc.tmpId) {
                            return contentColumn;
                        }

                        return {
                            ...contentColumn,
                            content: serializeImageBlockContent(updatedImages),
                            state: state ?? contentColumn.state,
                        };
                    })
                }
            }, this.postUpdatedRowToParent);
        };

        const openImageSelector = () => {
            this.setState({
                imageSelectorColumnTmpId: cc.tmpId,
            });
        };

        return (
            <div className="EditableContentSectionsRow-IframeForm ImageBlockForm" style={{
                backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                padding: Style.getSpacingStr(3),
                borderRadius: "12px"
            }}>
                {images.length === 0 ? (
                    <CoverImageButton
                        icon="gallery"
                        placeholder={localize("ValjBilder")}
                        onClick={openImageSelector}
                    />
                ) : (
                    <ImageBlockThumbnails
                        images={images}
                        onChange={(updatedImages: IImageBlockImage[]) => updateImages(updatedImages)}
                    />
                )}
                <Stack horizontal horizontalAlign="space-between" verticalAlign="center" tokens={{ childrenGap: 12 }} className="ImageBlockForm-footer">
                    <div>
                        {images.length > 0 && (
                            <DefaultButton text={localize("ADD_IMAGES")} onClick={openImageSelector} />
                        )}
                    </div>
                    <PrimaryButton
                        text={localize("Spara")}
                        disabled={images.length === 0}
                        onClick={() => updateImages(images, SpintrTypes.UberContentSectionState.IsDisplayed)}
                    />
                </Stack>
                {this.state.imageSelectorColumnTmpId === cc.tmpId && (
                    <FileSelector
                        multiSelect
                        initialSelection={images.map((image: IImageBlockImage) => ({
                            previewUrl: image.content,
                            data: image,
                        }))}
                        allowMultipleFiles
                        fileTypesString="image/png, image/jpeg"
                        fileTypes={["png", "jpeg", "jpg"]}
                        sourcesToDisplay={[0, ...(this.isAppEnabled(SpintrTypes.SpintrApp.Media) ? [7] : [])]}
                        fileUploadType={1}
                        customRequestUrl="/api/uploads/redactor/image"
                        enableMediaflow={this.props.enableMediaflow}
                        enableUnsplash={this.props.enableUnsplash}
                        renderSizeString={this.getImageSizeString}
                        onClose={() => {
                            this.setState({
                                imageSelectorColumnTmpId: undefined,
                            });
                        }}
                        onSelect={(data: any[]) => {
                            this.setState({
                                imageSelectorColumnTmpId: undefined,
                            });

                            updateImages(data
                                .map(toImageBlockImageFromSelection)
                                .filter((image: IImageBlockImage) => !!image.content));
                        }}
                    />
                )}
            </div>
        );
    }

    private selectType(cc, typeId, state?: SpintrTypes.UberContentSectionState, initialContent?: string) {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === cc.tmpId) {
                        return {
                            ...contentColumn,
                            type: typeId,
                            state: state ?? SpintrTypes.UberContentSectionState.IsEditing,
                            content: initialContent ?? contentColumn.content,
                            isNew: true
                        }
                    } else {
                        return contentColumn;
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }

    private createSessionBlockContent(): string {
        const content: IAcademySessionBlockContent = {
            blockKey: generateUuid(),
            title: "",
            description: "",
        };

        return JSON.stringify(content);
    }

    isAppEnabled(id) {
        return !!this.props.apps.items.find((a) => a.id === id && a.enabled);
    }

    private renderColumnTypeSelector(cc) {
        let types = [{
            text: localize("Text"),
            icon: "textalign-justifyleft",
            type: SpintrTypes.UberContentSectionType.Text,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Text);
            },
            enabled: true
        }, {
            enabled: this.props.enableExtendedPageBlockTypes,
            icon: "text",
            type: SpintrTypes.UberContentSectionType.Preamble,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Preamble, SpintrTypes.UberContentSectionState.IsDisplayed);
            },
            text: localize("Ingress"),
        }, {
            text: localize("Bilder"),
            icon: "image",
            type: SpintrTypes.UberContentSectionType.Image,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Image);
                this.setState({
                    imageSelectorColumnTmpId: cc.tmpId,
                });
            },
            enabled: true
        }, {
            text: localize("Video"),
            icon: "video",
            type: SpintrTypes.UberContentSectionType.Video,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Video);
            },
            enabled: true
        }, {
            text: localize("HIGHLIGHTED_TEXT"),
            icon: "quote-up",
            type: SpintrTypes.UberContentSectionType.HighlightedText,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.HighlightedText);
            },
            enabled: true
        }, {
            text: localize("DIVIDER"),
            icon: "minus",
            type: SpintrTypes.UberContentSectionType.Divider,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Divider, SpintrTypes.UberContentSectionState.IsDisplayed, "");
            },
            enabled: true
        }, {
            text: "iFrame",
            icon: "frame-2",
            type: SpintrTypes.UberContentSectionType.IFrame,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.IFrame);
            },
            enabled: true
        }, {
            text: localize("Formular"),
            icon: "note-1",
            type: SpintrTypes.UberContentSectionType.Form,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Form);
            },
            enabled: this.isAppEnabled(SpintrTypes.SpintrApp.Forms)
        }, {
            text: localize("Filer"),
            icon: "folder",
            type: SpintrTypes.UberContentSectionType.File,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.File);
            },
            enabled: this.isAppEnabled(SpintrTypes.SpintrApp.Files)
        }, {
            enabled: this.props.enableCrocus,
            icon: "chart",
            type: SpintrTypes.UberContentSectionType.DataWidget,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.DataWidget);
            },
            text: localize("TEASER_BOX_DATA"),
        }, {
            enabled: this.props.enableExtendedPageBlockTypes,
            icon: "box-1",
            type: SpintrTypes.UberContentSectionType.TeaserBox,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.TeaserBox);
            },
            text: localize("Textpuff"),
        }, {
            enabled: this.props.enableExtendedPageBlockTypes,
            icon: "calendar",
            type: SpintrTypes.UberContentSectionType.Calendar,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Calendar);
            },
            text: localize("Kalender"),
        },
        {
            enabled: this.props.enableExtendedPageBlockTypes,
            icon: "arrow-down-1",
            type: SpintrTypes.UberContentSectionType.ExpandableField,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.ExpandableField);
            },
            text: localize("ExpanderbartFalt"),
        },
        {
            enabled: this.props.enableExtendedPageBlockTypes,
            icon: "card",
            type: SpintrTypes.UberContentSectionType.Link,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Link);
            },
            text: localize("LankBlock"),
        }, {
            enabled: this.props.enableDirekten,
            icon: "home-1",
            type: SpintrTypes.UberContentSectionType.Direkten,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Direkten);
            },
            text: "Direkten",
        }, {
            enabled: this.props.enableExtendedPageBlockTypes,
            icon: "people",
            type: SpintrTypes.UberContentSectionType.UserList,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.UserList);
            },
            text: localize("Medarbetare"),
        }, {
            enabled: this.isAppEnabled(SpintrTypes.SpintrApp.Products),
            icon: "shopping-cart",
            type: SpintrTypes.UberContentSectionType.Products,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.Products);
            },
            text: localize("PRODUCTS")
        }, {
            enabled: this.props.enableTaxiFiles,
            icon: "car",
            type: SpintrTypes.UberContentSectionType.TaxiFiles,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.TaxiFiles, SpintrTypes.UberContentSectionState.IsDisplayed);
            },
            text: localize("TAXI_FILES"),
        }, {
            enabled: this.props.isAcademy,
            icon: "teacher",
            type: SpintrTypes.UberContentSectionType.AcademyQuestion,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.AcademyQuestion);
            },
            text: localize("Fraga"),
        }, {
            enabled: this.props.isAcademy,
            icon: "task",
            type: SpintrTypes.UberContentSectionType.AcademyTask,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.AcademyTask);
            },
            text: localize("TASK"),
        }, {
            enabled: this.props.isAcademy && !this.props.isAcademyGuide,
            icon: "calendar",
            type: SpintrTypes.UberContentSectionType.AcademySession,
            onClick: () => {
                this.selectType(
                    cc,
                    SpintrTypes.UberContentSectionType.AcademySession,
                    SpintrTypes.UberContentSectionState.IsEditing,
                    this.createSessionBlockContent());
            },
            text: localize("SESSION"),
        }, {
            enabled: this.isAppEnabled(SpintrTypes.SpintrApp.Academy),
            icon: "teacher",
            type: SpintrTypes.UberContentSectionType.AcademyCourse,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.AcademyCourse);
            },
            text: localize("appAcademy"),
        }, {
            enabled: true,
            icon: "document-text",
            type: SpintrTypes.UberContentSectionType.NewsFeed,
            onClick: () => {
                this.selectType(cc, SpintrTypes.UberContentSectionType.NewsFeed);
            },
            text: localize("NEWS_FEED"),
        }];

        types = types.filter((t) =>
            t.enabled && this.props.enabledColumnTypes?.length > 0
                ? this.props.enabledColumnTypes.includes(t.type)
                : t.enabled
        );

        if (this.props.isSmallViewMode) {
            return (
                <Modal
                    isOpen={true}
                    className="columnTypeSelectorModal"
                    onDismiss={() => { }}
                    isModeless={true}
                    forceFocusInsideTrap={true}
                    styles={{ main: { minHeight: 0 } }}
                >
                    <div className="columnTypeSelector box-shadow-and-border" ref={this.typeSelector}>
                        {/* {types.length > 3 && this.renderTypeSearchBox()} */}
                        <div
                            className={classNames("typeSelectorContainer", {
                                ["smallViewMode"]: this.props.isSmallViewMode,
                            })}
                        >
                            <div
                                className={classNames("columnContainer", { ["smallViewMode"]: this.props.isSmallViewMode })}
                                style={{
                                    columnGap: Style.getSpacingStr(2),
                                }}
                            >
                                {types
                                    .filter((t) => t.text.toLowerCase().includes(this.state.searchText.toLowerCase()))
                                    .map((o) => {
                                        return this.renderColumnType(types.indexOf(o), o.text, o.icon, o.onClick);
                                    })}
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        } else {
            return (
                <div
                    ref={this.typeSelector}
                    className={classNames("box-shadow-and-border columnTypeSelector", {
                        ["smallViewMode"]: this.props.isSmallViewMode,
                    })}
                >
                    {/* {types.length > 2 && this.renderTypeSearchBox()} */}

                    <div
                        className={classNames("columnContainer", { ["smallViewMode"]: this.props.isSmallViewMode })}
                        style={{

                            columnGap: Style.getSpacingStr(2),
                        }}
                    >
                        {types
                            .filter((t) => t.text.toLowerCase().includes(this.state.searchText.toLowerCase()))
                            .map((o) => {
                                return this.renderColumnType(types.indexOf(o), o.text, o.icon, o.onClick);
                            })}
                    </div>
                </div>
            );
        }
    }

    private postUpdatedRowToParent() {
        this.props.contentRow.onChange(this.state.contentRow);
    }

    private renderColumnPlusSign(cc) {
        return (
            <a onClick={() => {
                this.setState({
                    contentRow: {
                        ...this.state.contentRow,
                        uberContentColumns: this.state.contentRow.uberContentColumns.map(uberContentColumn => {
                            if (cc.tmpId === uberContentColumn.tmpId) {
                                return {
                                    ...uberContentColumn,
                                    state: SpintrTypes.UberContentSectionState.IsSelectingType
                                }
                            } else {
                                return uberContentColumn;
                            }
                        })
                    }
                }, this.postUpdatedRowToParent);
            }}>
                <div style={{
                    backgroundColor: Style.getHexFromSpintrColor("visageMidBlueBackground"),
                    height: "150px",
                    textAlign: "center",
                    width: "100%",
                    display: "inline-block",
                    borderRadius: "12px",
                    cursor: "pointer"
                }}>
                    <div style={{
                        display: "inline-block",
                        position: "relative",
                        transform: "translateY(-50%)",
                        msTransform: "translateY(-50%)",
                        top: "50%"
                    }}>
                        <Visage2Icon icon="add-circle" color="visageMidBlue" />
                    </div>
                </div>
            </a>
        )
    }

    moveColumn(tmpId: string, newIndex: number) {
        const columns = [...this.state.contentRow.uberContentColumns];
        const column = columns.find(x => x.tmpId === tmpId);

        if (!column) {
            return;
        }

        columns.splice(columns.indexOf(column), 1);
        columns.splice(newIndex, 0, column);

        for (let i = 0; i < columns.length; i++) {
            columns[i].index = i;
        }

        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: columns
            }
        }, this.postUpdatedRowToParent);
    }

    private renderContentColumn(cc, columnCount) {
        const actions = [[], []];

        actions[0].push({
            icon: "menu",
            title: localize("Flytta"),
            className: "drag-handle",
        })

        if (columnCount < 3) {
            actions[1].push({
                icon: "add",
                title: localize("ADD_COLUMN"),
                onClick: () => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: [
                                ...this.state.contentRow.uberContentColumns,
                                {
                                    id: 0,
                                    tmpId: uniqueId(),
                                    index: columnCount,
                                    type: SpintrTypes.UberContentSectionType.Text,
                                    state: SpintrTypes.UberContentSectionState.IsDisplayingPlusSign,
                                    content: '',
                                }
                            ]
                        }
                    }, this.postUpdatedRowToParent);
                }
            })
        }

        if (columnCount > 1) {
            const index = this.state.contentRow.uberContentColumns.indexOf(cc);
            const isFirst = index === 0;
            const isLast =  index === this.state.contentRow.uberContentColumns.length - 1;

            if (!isFirst) {
                actions[1].push({
                    icon: "arrow-left",
                    title: localize("MOVE_LEFT"),
                    onClick: () => {
                        this.moveColumn(cc.tmpId, index - 1);
                    }
                });
            }

            if (!isLast) {
                actions[1].push({
                    icon: "arrow-right-1",
                    title: localize("MOVE_RIGHT"),
                    onClick: () => {
                        this.moveColumn(cc.tmpId, index + 1);
                    }
                });
            }
        }

        if (
            cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            (cc.type === SpintrTypes.UberContentSectionType.Text ||
                cc.type === SpintrTypes.UberContentSectionType.ExpandableField ||
                cc.type === SpintrTypes.UberContentSectionType.Direkten ||
                cc.type === SpintrTypes.UberContentSectionType.UserList ||
                cc.type === SpintrTypes.UberContentSectionType.Products ||
                cc.type === SpintrTypes.UberContentSectionType.AcademyQuestion ||
                cc.type === SpintrTypes.UberContentSectionType.AcademyTask ||
                cc.type === SpintrTypes.UberContentSectionType.AcademySession ||
                cc.type === SpintrTypes.UberContentSectionType.AcademyCourse ||
                cc.type === SpintrTypes.UberContentSectionType.HighlightedText ||
                cc.type === SpintrTypes.UberContentSectionType.Image)
        ) {
            actions[1].push({
                icon: "edit",
                title: localize("Redigera"),
                onClick: () => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                return {
                                    ...contentColumn,
                                    state: contentColumn.tmpId === cc.tmpId ?
                                        SpintrTypes.UberContentSectionState.IsEditing :
                                        contentColumn.state,
                                }
                            })
                        }
                    }, this.postUpdatedRowToParent);
                }
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            cc.type === SpintrTypes.UberContentSectionType.Form) {

            const inlineFormPattern = /(?:class="redactorInlineFolder)\s([a-z]*-[0-9]*)">([A-Za-zÀ-ÖØ-öø-ÿ\d\s]*)/igm;

            let match, formId;

            while ((match = inlineFormPattern.exec(cc.content))) {
                formId = parseInt(match[1].match(/(\d+)/)[0]);

                if (isNaN(formId)) {
                    continue;
                }
            };

            actions[1].push({
                icon: "edit",
                title: localize("CHANGE_FORM"),
                onClick: () => {
                    this.setState({
                        showFormSelectorDialog: true,
                        isLoadingForms: true,
                        columnTmpIdToAddFormTo: cc.tmpId
                    }, () => {
                        api.get(`/api/v1/survey/list`, {
                            params: {
                                take: 9999
                            }
                        }).then((response: AxiosResponse) => {
                            const forms = response.data.filter(f => !f.isDeleted);

                            this.setState({
                                isLoadingForms: false,
                                forms,
                                selectedForm: forms.find(f => f.id === formId) || response.data[0]
                            })
                        });
                    });
                }
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            cc.type === SpintrTypes.UberContentSectionType.NewsFeed) {
            actions[1].push({
                icon: "edit",
                title: localize("Nyhetskategori"),
                onClick: () => {
                    this.openNewsFeedCategorySelector(cc.tmpId, cc.content);
                }
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            cc.type === SpintrTypes.UberContentSectionType.IFrame) {
            actions[1].push({
                icon: "edit",
                title: localize("CHANGE_IFRAME"),
                onClick: () => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                if (contentColumn.tmpId === cc.tmpId) {
                                    return {
                                        ...contentColumn,
                                        state: SpintrTypes.UberContentSectionState.IsEditing
                                    }
                                } else {
                                    return contentColumn;
                                }
                            })
                        }
                    }, this.postUpdatedRowToParent);
                }
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            cc.type === SpintrTypes.UberContentSectionType.Link) {
            actions[1].push({
                icon: "edit",
                title: localize("RedigeraLank"),
                onClick: () => {
                    this.setState({
                        contentRow: {
                            ...this.state.contentRow,
                            uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                if (contentColumn.tmpId === cc.tmpId) {
                                    return {
                                        ...contentColumn,
                                        state: SpintrTypes.UberContentSectionState.IsEditing
                                    }
                                } else {
                                    return contentColumn;
                                }
                            })
                        }
                    }, this.postUpdatedRowToParent);
                }
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            cc.type === SpintrTypes.UberContentSectionType.Calendar) {

            const inlineCalendarPattern = /(?:class="redactorInlineFolder)\s([a-z]*-[0-9]*)">([A-Za-zÀ-ÖØ-öø-ÿ\d\s]*)/igm;

            let match, calendarId;

            while ((match = inlineCalendarPattern.exec(cc.content))) {
                calendarId = parseInt(match[1].match(/(\d+)/)[0]);

                if (isNaN(calendarId)) {
                    continue;
                }
            };

            actions[1].push({
                icon: "edit",
                title: localize("CHANGE_CALENDAR"),
                onClick: () => {
                    this.setState({
                        showCalendarSelectorDialog: true,
                        isLoadingCalendars: true,
                        columnTmpIdToAddCalendarTo: cc.tmpId
                    }, () => {
                        api.get(`/api/v1/calendar/currentuser`, {
                            params: {
                                take: 9999
                            }
                        }).then((response: AxiosResponse) => {
                            const calendars = response.data //.filter(f => !f.isDeleted);

                            this.setState({
                                isLoadingCalendars: false,
                                calendars,
                                selectedCalendar: calendars.find(f => f.id === calendarId) || response.data[0]
                            })
                        });
                    });
                }
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayed &&
            cc.type === SpintrTypes.UberContentSectionType.File) {
            actions[1].push({
                icon: "edit",
                title: localize("Redigera"),
                onClick: () => {
                    this.setState({
                        showFilePicker: true,
                        columnTmpIdToAddFileTo: cc.tmpId,
                    });
                }
            });

            if (cc.content) {
                const inlineFolderPattern = /(?:\<(?:span|font|p)[^\<]*?\>\[@Folder:([0-9]+)@\]\<\/(?:span|font|p)\>(.+?)\<(?:span|font|p)[^\<]*?\>\[\/@Folder@\]\<\/(?:span|font|p)\>)/gim;
                const inlineSharePointListSearchPattern = /<div><div><span class="redactorInlineFolder sharePoint">(.+?)<\/span><\/div>(.+?)<div><span class="redactorInlineFolder">(.+?)<\/span><\/div><\/div>/gim;

                if (inlineFolderPattern.exec(cc.content) || inlineSharePointListSearchPattern.exec(cc.content)) {
                    actions[1].push({
                        icon: "edit",
                        title: localize("AndraNamn"),
                        onClick: () => {
                            this.setState(
                                {
                                    contentRow: {
                                        ...this.state.contentRow,
                                        uberContentColumns: this.state.contentRow.uberContentColumns.map(
                                            (contentColumn) => {
                                                if (contentColumn.tmpId === cc.tmpId) {
                                                    return {
                                                        ...contentColumn,
                                                        state: SpintrTypes.UberContentSectionState.IsEditing,
                                                    };
                                                } else {
                                                    return contentColumn;
                                                }
                                            }
                                        ),
                                    },
                                },
                                this.postUpdatedRowToParent
                            );
                        },
                    });
                }
            }
        }

        if (this.props.blockLinkUberId != null &&
            cc.state !== SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
            const canCopyBlockLink = this.props.blockLinkUberId > 0;

            actions[1].push({
                icon: "link",
                title: localize("KopieraLank"),
                className: canCopyBlockLink ? undefined : "block-link-disabled",
                onClick: canCopyBlockLink ? () => {
                    this.copyBlockLink(cc);
                } : undefined
            });
        }

        if (cc.state === SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
            actions[1].push({
                icon: "trash",
                title: localize("TaBortSektionen"),
                onClick: () => {
                    const columnTmpId = cc.tmpId;
                    const rowTmpId = this.props.contentRow.tmpId;
                    const isMultipleColumns = this.props.contentRow.uberContentColumns.length > 1;

                    if (isMultipleColumns) {
                        this.setState({
                            contentRow: {
                                ...this.state.contentRow,
                                uberContentColumns: this.state.contentRow.uberContentColumns.filter(contentColumn => {
                                    return contentColumn.tmpId !== columnTmpId
                                })
                            }
                        }, this.postUpdatedRowToParent);
                    } else {
                        this.props.contentRow.removeRow(rowTmpId);
                    }
                }
            });
        }

        if (cc.state !== SpintrTypes.UberContentSectionState.IsDisplayingPlusSign) {
            actions[1].push({
                icon: "trash",
                title: localize("TaBort"),
                onClick: () => {
                    const removeColumn = () => {
                        this.setState({
                            contentRow: {
                                ...this.state.contentRow,
                                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                                    if (contentColumn.tmpId === cc.tmpId) {
                                        return {
                                            ...contentColumn,
                                            state: SpintrTypes.UberContentSectionState.IsDisplayingPlusSign,
                                            content: ""
                                        }
                                    } else {
                                        return contentColumn;
                                    }
                                })
                            }
                        }, this.postUpdatedRowToParent);
                    };

                    if (cc.type === SpintrTypes.UberContentSectionType.AcademySession &&
                        this.props.confirmRemoveSessionBlock) {
                        const blockKey = cc.content ? JSON.parse(cc.content)?.blockKey : null;

                        if (blockKey) {
                            this.props.confirmRemoveSessionBlock(blockKey, removeColumn);
                            return;
                        }
                    }

                    this.props.dispatch(setConfirmPopup({
                        isOpen: true,
                        message: localize("ArDuSakerPaAttDuVillTaBortDettaInnehall"),
                        onConfirm: removeColumn
                    }));
                }
            });
        }

        const displayBorder = true;

        return (
            <div className="content-column" key={cc.tmpId}>
                <DivWithHoverActions disableHoverEffects={false}
                    actions={actions}
                    displayBorder={displayBorder}>
                    {
                        this.contentTypes.find(c => c.typeId == cc.type).render(cc)
                    }
                </DivWithHoverActions>
                {
                    this.state.copiedLinkColumnTmpId === cc.tmpId && (
                        <div className="block-link-copied-confirmation">
                            <Label size="body-3" color="dark-grey">
                                {
                                    localize("LankKopierad")
                                }
                            </Label>
                        </div>
                    )
                }
            </div>
        )
    }

    private renderContentRow() {
        return (
            <div
                className={[
                    "content-row",
                    "column-count-" + this.state.contentRow.uberContentColumns.length
                ].join(" ")}
                {...this.props.handleProps}
            >
                {
                    this.state.contentRow.uberContentColumns.map(cc => {
                        return this.renderContentColumn(cc, this.state.contentRow.uberContentColumns.length);
                    })
                }
            </div>
        )
    }

    private handleDismissDialog = () => {
        this.setState({
            showFormSelectorDialog: false
        });
    }

    private handleConfirmDialog = () => {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === this.state.columnTmpIdToAddFormTo) {
                        return {
                            ...contentColumn,
                            content: '<div><span class="redactorInlineFolder form-' +
                                this.state.selectedForm.id +
                                '">' +
                                this.state.selectedForm.name +
                                '</span></div>',
                            state: SpintrTypes.UberContentSectionState.IsDisplayed
                        }
                    } else {
                        return contentColumn;
                    }
                })
            },
            showFormSelectorDialog: false
        }, this.postUpdatedRowToParent);
    }

    private handleConfirmCalendarDialog = () => {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === this.state.columnTmpIdToAddCalendarTo) {
                        return {
                            ...contentColumn,
                            content: '<div><span class="redactorInlineFolder calendar-' +
                                this.state.selectedCalendar.id +
                                '">' +
                                this.state.selectedCalendar.name +
                                '</span></div>',
                            state: SpintrTypes.UberContentSectionState.IsDisplayed
                        }
                    } else {
                        return contentColumn;
                    }
                })
            },
            showCalendarSelectorDialog: false
        }, this.postUpdatedRowToParent);
    }

    private toggleFilePicker = () => {
        this.setState((prevState) => ({
            showFilePicker: !prevState.showFilePicker
        }));
    }

    private onChangeForm = (
        _: React.FormEvent<IComboBox>,
        option?: IComboBoxOption) => {
        this.setState({
            selectedForm: this.state.forms.find(f => f.id === option.key)
        });
    }

    private renderFormSelectorDialog() {
        const comboBoxBasicOptions: IComboBoxOption[] = [];

        if (this.state.forms) {
            this.state.forms.map((f) => {
                comboBoxBasicOptions.push({
                    key: f.id,
                    text: f.name
                });
            });
        }

        return (
            <CustomDialog
                title={localize("SELECT_FORM")}
                show={this.state.showFormSelectorDialog}
                onDismiss={this.handleDismissDialog}
                onConfirm={this.handleConfirmDialog}
            >
                <div>
                    {
                        this.state.isLoadingForms ?
                            <Loader /> :
                            <div>
                                <ComboBox
                                    selectedKey={this.state.selectedForm ? this.state.selectedForm.id : null}
                                    onChange={this.onChangeForm}
                                    options={comboBoxBasicOptions}
                                />
                            </div>
                    }
                </div>
            </CustomDialog>
        )
    }

    private renderCalendarSelectorDialog() {
        const comboBoxBasicOptions: IComboBoxOption[] = [];

        if (this.state.calendars) {
            this.state.calendars.map((f) => {
                comboBoxBasicOptions.push({
                    key: f.id,
                    text: f.name
                });
            });
        }

        return (
            <CustomDialog
                title={localize("ValjKalender")}
                show={this.state.showCalendarSelectorDialog}
                onDismiss={() => { this.setState({ showCalendarSelectorDialog: false }) }}
                onConfirm={this.handleConfirmCalendarDialog}
            >
                <div>
                    {
                        this.state.isLoadingCalendars ?
                            <Loader /> :
                            <div>
                                <ComboBox
                                    selectedKey={this.state.selectedCalendar ? this.state.selectedCalendar.id : null}
                                    onChange={(_ev, option) => { this.setState({ selectedCalendar: this.state.calendars.find(f => f.id === option.key) }) }}
                                    options={comboBoxBasicOptions}
                                />
                            </div>
                    }
                </div>
            </CustomDialog>
        )
    }

    private onChangeAcademyCourse = (
        _: React.FormEvent<IComboBox>,
        option?: IComboBoxOption) => {
        this.setState({
            selectedAcademyCourse: this.state.academyCourses.find(f => f.id === option.key)
        });
    }

    private handleDismissAcademyCourseDialog = () => {
        this.setState({
            showAcademyCourseSelectorDialog: false
        });
    }

    private handleConfirmAcademyCourseDialog = () => {
        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    if (contentColumn.tmpId === this.state.columnTmpIdToAddAcademyCourseTo) {
                        return {
                            ...contentColumn,
                            content: '<div><span class="redactorAcademy academy-' +
                                this.state.selectedAcademyCourse.id +
                                (this.state.selectedAcademyCourse.isGuide ? ' isGuide' : '') +
                                '">' +
                                this.state.selectedAcademyCourse.text +
                                '</span></div>',
                            state: SpintrTypes.UberContentSectionState.IsDisplayed
                        }
                    } else {
                        return contentColumn;
                    }
                })
            },
            showAcademyCourseSelectorDialog: false,
        }, this.postUpdatedRowToParent);
    }

    private renderAcademyCourseSelectorDialog() {
        return (
            <CustomDialog
                title={localize("SELECT_COURSE_OR_GUIDE")}
                show={this.state.showAcademyCourseSelectorDialog}
                onDismiss={this.handleDismissAcademyCourseDialog}
                onConfirm={this.handleConfirmAcademyCourseDialog}
            >
                <div>
                    {this.state.isLoadingAcademyCourses ? (
                        <Loader />
                    ) : (
                        <div>
                            <ComboBox
                                selectedKey={
                                    this.state.selectedAcademyCourse ? this.state.selectedAcademyCourse.id : null
                                }
                                onChange={this.onChangeAcademyCourse}
                                options={this.state.academyCourses}
                            />
                        </div>
                    )}
                </div>
            </CustomDialog>
        );
    }

    private onSelectFilePicker = (data, source) => {
        const selectedItems = Array.isArray(data) ? data : [data];

        const contents = selectedItems.map((item) => {
            if (source === SpintrTypes.FolderRootSource.SharePointSearch) {
                return (
                    '<div><div><span class="redactorInlineFolder sharePoint">[@SharePointListSearch:' +
                    item.id +
                    "@]</span></div>" +
                    item.name +
                    '<div><span class="redactorInlineFolder">[/@SharePointListSearch@]</span></div></div><br />'
                );
            } else if (
                (source === SpintrTypes.FolderRootSource.Office365Public || source === SpintrTypes.FolderRootSource.Office365Private) &&
                !item.isDirectory
            ) {
                return (
                    '<div><div><span class="redactorSingleFile external">[@ExternalFile:' +
                    item.id +
                    ":" +
                    source +
                    "@]</span></div>" +
                    item.name +
                    '<div><span class="redactorSingleFile external">[/@ExternalFile@]</span></div></div><br />'
                );
            } else if (
                (source === SpintrTypes.FolderRootSource.Office365Public || source === SpintrTypes.FolderRootSource.Office365Private) &&
                item.isDirectory
            ) {
                return (
                    '<div><div><span class="redactorInlineFolder external">[@ExternalFolder:' +
                    item.id +
                    ":" +
                    source +
                    "@]</span></div>" +
                    item.name +
                    '<div><span class="redactorInlineFolder external">[/@ExternalFolder@]</span></div></div><br />'
                );
            } else if (source === SpintrTypes.FolderRootSource.GoogleDrive) {
                const typeStr = item.isDirectory ? "Folder" : "File";

                return (
                    `<div><div><span class="redactorSingleFile external">[@External${typeStr}:` +
                    item.id +
                    ":" +
                    source +
                    "@]</span></div>" +
                    item.name +
                    `<div><span class="redactorSingleFile external">[/@External${typeStr}@]</span></div></div><br />`
                );
            } else if (item.isDirectory) {
                return (
                    '<div><div><span class="redactorInlineFolder">[@Folder:' +
                    item.id +
                    "@]</span></div>" +
                    item.name +
                    '<div><span class="redactorInlineFolder">[/@Folder@]</span></div></div><br />'
                );
            }

            return (
                '<div><div><span class="redactorSingleFile">[@File:' +
                item.id +
                "@]</span></div>" +
                item.name +
                '<div><span class="redactorSingleFile">[/@File@]</span></div></div><br />'
            );
        });

        this.setState(
            {
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map((contentColumn) => {
                        if (contentColumn.tmpId === this.state.columnTmpIdToAddFileTo) {
                            return {
                                ...contentColumn,
                                content: contents.join(""),
                                state: SpintrTypes.UberContentSectionState.IsDisplayed,
                            };
                        } else {
                            return contentColumn;
                        }
                    }),
                },
                showFormSelectorDialog: false,
            },
            this.postUpdatedRowToParent
        );
    }

    private renderFilePicker() {
        if (!this.state.showFilePicker) {
            return null;
        }

        return (
            <FilePicker
                onClose={this.toggleFilePicker}
                onSelect={this.onSelectFilePicker}
                showFiles
                selectFolders
                allowMultipleFiles
                sourcesToDisplay={[
                    SpintrTypes.FolderRootSource.SpintrPublic,
                    SpintrTypes.FolderRootSource.Office365Public,
                    ...(this.props.enableSharePointListSearch ? [SpintrTypes.FolderRootSource.SharePointSearch] : []),
                    SpintrTypes.FolderRootSource.GoogleDrive,
                ]}
                source={SpintrTypes.FolderRootSource.SpintrPublic}
            />
        );
    }

    private copyBlockLink = (cc: UberContentColumn) => {
        const anchorId = cc.anchorId || generateBlockAnchorId();

        if (!cc.anchorId) {
            this.setState({
                contentRow: {
                    ...this.state.contentRow,
                    uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                        return contentColumn.tmpId === cc.tmpId ?
                            { ...contentColumn, anchorId } :
                            contentColumn;
                    })
                }
            }, this.postUpdatedRowToParent);
        }

        const url = getBlockLink(this.props.blockLinkUberId, anchorId);

        if (!navigator.clipboard) {
            this.setState({ blockLinkToCopyManually: url });

            return;
        }

        navigator.clipboard.writeText(url).then(() => {
            window.clearTimeout(this.copiedLinkTimeout);

            this.setState({ copiedLinkColumnTmpId: cc.tmpId });

            this.copiedLinkTimeout = window.setTimeout(() => {
                this.setState({ copiedLinkColumnTmpId: undefined });
            }, 3000);
        }, () => {
            this.setState({ blockLinkToCopyManually: url });
        });
    }

    private editOnDoubleClick = (cc) => {
        if (window.getSelection) {
            // prevent weird selection issue in chrome when double clicking on text block
            window.getSelection().empty();
        }

        this.setState({
            contentRow: {
                ...this.state.contentRow,
                uberContentColumns: this.state.contentRow.uberContentColumns.map(contentColumn => {
                    return {
                        ...contentColumn,
                        state: contentColumn.tmpId === cc.tmpId ?
                            SpintrTypes.UberContentSectionState.IsEditing :
                            contentColumn.state
                    }
                })
            }
        }, this.postUpdatedRowToParent);
    }
}

const mapStateToProps = (state: IApplicationState, props) => {
    return {
        ...props,
        enableCrocus: state.instance.get("crocusAvailable"),
        enableExtendedPageBlockTypes: state.instance.get("enableExtendedPageBlockTypes"),
        enableMediaflow: state.instance.get("enableMediaflow"),
        enableUnsplash: state.instance.get("enableUnsplash"),
        enableSharePointListSearch: state.profile.active.office365Connected && state.instance.get("enableSharePointListSearch"),
        enableDirekten: state.instance.get("enableDirekten"),
        enableTaxiFiles: state.instance.get("enableTaxiFiles"),
        instance: state.instance,
        isSmallViewMode: state.ui.isSmallViewMode,
        apps: state.app
    };
};

export default connect(mapStateToProps)(EditableContentSectionsRow)
